export const updateRepeatStatusEndpoint = '/berths/bookings/repeat/status' as const
